export default "__VITE_ASSET__DMVcpPEb__"